import React, { useEffect } from 'react'
import styles from './style.module.scss'
import { useHistory, useLocation, useParams } from 'react-router'
import { SectionWrapper } from '@Root/HOCs'
import { CreateVenueActivity } from './Create'
import { EditVenueActivity } from './Edit'
import { useDispatch, useSelector } from 'react-redux'
import { modalActions } from '@Root/store'
import { studentCourseSessionSelectors, studentCourseSessionActions } from '@Store/studies/studentCourseSession/index'
import { venueActivityActions } from '@Store/studies'
import { fieldTooltipManagerActions } from '@Store/fieldTooltipManager/index'
import { hesaActions } from '@Store/contact/person'

export const VenueActivityPage = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const programmeRecord = useSelector(studentCourseSessionSelectors.programmeRecord)
  const pathname = location.pathname
  const isNew = pathname.includes('new')
  const isDuplicate = pathname.includes('duplicate')
  const { studyProgrammeId, contactId } = useParams()
  const DEFAULT_URL = `/home/studies/programmes/study/${contactId}/${studyProgrammeId}/off_venue_activity`

  useEffect(() => {
    dispatch(studentCourseSessionActions.get({ studyProgrammeId, isCopy: isDuplicate }))
    dispatch(venueActivityActions.getOptions())
    dispatch(fieldTooltipManagerActions.getHesaDescriptions())
    dispatch(hesaActions.getDynamicOptions({ contactId }))
    return () => {
      dispatch(studentCourseSessionActions.clearData({}))
      dispatch(venueActivityActions.clearData())
    }
  }, [])

  const onOpenDescriptionModal = (description, title) => {
    new Promise((resolve, reject) => {
      dispatch(modalActions.showModal('NotificationModal', { text: description, clickRejectButtonHandler: reject, clickResolveButtonHandler: resolve, title }))
    }).finally(() => dispatch(modalActions.hideModal()))
  }
  const handleBack = () => {
    history.push(DEFAULT_URL)
  }
  return (
    <SectionWrapper hasBackButton backButtonText={'Off Venue Activity Details'} clickBackButtonHandler={handleBack} activeName>
      <div className={styles.sections}>
        {isNew ? (
          <CreateVenueActivity onOpenDescriptionModal={onOpenDescriptionModal} programmeRecord={programmeRecord} handleBack={handleBack} />
        ) : (
          <EditVenueActivity onOpenDescriptionModal={onOpenDescriptionModal} programmeRecord={programmeRecord} />
        )}
      </div>
    </SectionWrapper>
  )
}
